<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
        <h2>Constancia de Empleados</h2>
    </div>
</div>
  
<div class="ibox">
    <div class="ibox-content">
        <mat-error *ngIf="Invalido" class="Invalido">{{MensajeError}}</mat-error>
        <div class="row">
            <div class="col-lg">
                <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
                <div>
                    <label class="col-form-label font-bold">Modelo Constancia</label>
                    <comboTools
                        [list]=modelosList
                        selected='modelo'
                        [formParent]="registerForm"
                        filter="descripcion"
                        soloDescri=true
                        ph='Modelo'
                    ></comboTools>
                </div>
                </form>
            </div>
            <div class="col-lg">
                <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
                <div>
                    <label class="col-form-label font-bold" for="fecha">Fecha</label>
                    <div class="fechaC">
                        <p-calendar selectOtherMonths="true" formControlName="fecha" dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl></p-calendar>
                        <!-- <div *ngIf="registerForm.fecha.errors?.required && (registerForm.fecha?.dirty || registerForm.fecha?.touched || submitted)" class="text-danger">La Fecha es requerida</div> -->
                    </div>
                </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-lg">
                <label class="col-form-label font-bold">Legajo</label>
                <p-dropdown [options]="personalList" [(ngModel)]="selectedLegajo" optionLabel="code" [filter]="true" 
                    filterBy="code,displayName" [showClear]="true" placeholder="Seleccione Empleado"
                    (onChange)="onChangeLegajo($event)">
                    <ng-template pTemplate="selectedItem">
                        <div class=" personal-item personal-item-value"  *ngIf="selectedLegajo">
                            <div>{{selectedLegajo.code}} - {{selectedLegajo.displayName}}</div>
                        </div>
                    </ng-template>
                    <ng-template let-personalList pTemplate="item">
                        <div class="personal-item">
                            <div>{{personalList.code}} - {{personalList.displayName}}</div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
            <div class="col-lg">
                <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
                <div>
                    <label class="col-form-label font-bold">Sociedad</label>
                    <comboTools
                        [list]=sociedadesList
                        selected='sociedad'
                        [formParent]="registerForm"
                        filter="descripcion"
                        ph='Sociedad'
                    ></comboTools>
                </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-lg">
                <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
                <div>
                    <label class="col-form-label font-bold">Sede</label>
                    <comboTools
                        [list]=sedesList
                        selected='sede'
                        [formParent]="registerForm"
                        filter="descripcion"
                        (SelectedChange)="onChangeSede($event)"
                        ph='Sede'
                    ></comboTools>
                </div>
                </form>
            </div>
            <div class="col-lg">
                <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
                <div>
                    <label class="col-form-label font-bold">Subsede</label>
                    <comboTools
                        [list]=subsedesList
                        selected='subSede'
                        [formParent]="registerForm"
                        filter="descripcion"
                        ph='Subsede'
                    ></comboTools>
                </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-lg">
                <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
                <div>
                    <label class=" col-form-label font-bold">Firma</label>
                    <input formControlName="firma" maxlength="50" name ="selectedFirma" type="text" class="form-control"/>
                </div>
                </form>
            </div>
        </div>
        
        <br>
        <div class="buttons">
            <button class="btn btn-primary" type="submit" (click)="imprimir()">Imprimir</button>
            <button class="btn btn-secondary" type="submit" (click)="verResultados()">Ver</button>
        </div>  
        
        <div *ngIf="showDetails" class="container">
            <div class="row">
                <div class="col-lg-5"></div>
                <div class="col-lg-2">
                    <mat-slider min="0" max="100" step="1" [(ngModel)]="tamanio" thumbLabel (change)="cambiarZoom()"></mat-slider>
                </div>
                <div class="col-lg-5"></div>
            </div>
            
            <pdf-viewer [src]="pdfSource"
                        [original-size]="false"
                        [zoom]=zoom
            ></pdf-viewer>
        </div>
      
    </div>  
</div>
  